import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useRouter } from 'next/router';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const Loader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  const onLoadingOn = (url) => {
    if (router.pathname !== url) {
      setIsLoading(true);
    }
  };
  const onLoadingOff = () => setIsLoading(false);

  useEffect(() => {
    router.events.on('routeChangeStart', onLoadingOn);
    router.events.on('routeChangeComplete', onLoadingOff);
    router.events.on('routeChangeError', onLoadingOff);

    return () => {
      router.events.off('routeChangeStart', onLoadingOn);
      router.events.off('routeChangeComplete', onLoadingOff);
      router.events.off('routeChangeError', onLoadingOff);
    };
  }, []);

  return <View isLoading={isLoading} />;
};

const fill = keyframes`
  100% {
    width: 100%
  }
`;

const View = styled.div`
  display: ${({ isLoading }) => (isLoading ? 'flex' : 'none')};
  position: fixed;
  width: 0;
  top: 0;
  left: 0;
  height: 3px;
  background: ${Colors.main_blue};
  z-index: 100;
  align-items: center;
  justify-content: center;
  animation-name: ${fill};
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;
